import React from "react";
import { Coins, Lock, Sparkles, Target, TrendingUp } from "lucide-react";
import { formatDrawCoin, MAX_SELECTION } from "../../utils/bondDrawHelpers";

const BondDrawTicket = ({
  ticket,
  picks = 0,
  selectedNumbers = [],
  locked = false,
  embedded = false,
  userCoin = null,
  poolActive = null,
}) => {
  const hasPicks = picks > 0;
  const odds = ticket?.odds || 0;
  const stake = ticket?.stake || 0;
  const maxWin = ticket?.maxWin || 0;
  const reserve = ticket?.reserve || 0;
  const hitPct = Math.round(((ticket?.hitProbability || 0) * 100));
  const coinBalance = userCoin != null ? Math.floor(Number(userCoin) || 0) : null;
  const insufficientCoin = coinBalance != null && hasPicks && !locked && stake > coinBalance;
  const insufficientPool =
    poolActive != null && hasPicks && !locked && reserve > 0 && poolActive < reserve;
  const showError = insufficientCoin || insufficientPool;

  return (
    <div
      className={`bdraw-ticket${embedded ? " embedded" : ""}${locked ? " locked" : ""}${showError ? " warn" : ""}`}
    >
      {!embedded ? (
        <div className="bdraw-ticket-head">
          <span className="bdraw-ticket-kicker">
            {locked ? (
              <>
                <Lock size={9} strokeWidth={2.5} /> Reserved
              </>
            ) : (
              "Ticket"
            )}
          </span>
          <span className="bdraw-ticket-picks">
            <Sparkles size={10} strokeWidth={2.5} />
            {hasPicks
              ? `${picks}/${MAX_SELECTION}${hitPct ? ` · ${hitPct}% hit` : ""}`
              : `Up to ${MAX_SELECTION}`}
          </span>
        </div>
      ) : null}

      {locked && selectedNumbers.length > 0 ? (
        <div className="bdraw-ticket-numbers">
          {selectedNumbers.map((n) => (
            <span key={n} className="bdraw-ticket-num">
              {n}
            </span>
          ))}
        </div>
      ) : null}

      <div className="bdraw-ticket-row">
        <div className="bdraw-ticket-cell">
          <span className="bdraw-ticket-label">
            <Coins size={10} strokeWidth={2.25} /> Stake
          </span>
          <strong>{hasPicks ? formatDrawCoin(stake) : "—"}</strong>
        </div>
        <div className="bdraw-ticket-cell">
          <span className="bdraw-ticket-label">
            <Target size={10} strokeWidth={2.25} /> Odds
          </span>
          <strong>{hasPicks ? `${odds.toFixed(2)}x` : "—"}</strong>
        </div>
        <div className="bdraw-ticket-cell hi">
          <span className="bdraw-ticket-label">
            <TrendingUp size={10} strokeWidth={2.25} /> Max
          </span>
          <strong>{hasPicks ? formatDrawCoin(maxWin) : "—"}</strong>
        </div>
      </div>

      {hasPicks && reserve > 0 ? (
        <p className="bdraw-ticket-meta">
          Pool hold {formatDrawCoin(reserve)} COIN
        </p>
      ) : null}

      {insufficientCoin ? (
        <p className="bdraw-ticket-note error">
          Need {formatDrawCoin(stake - coinBalance)} more COIN.
        </p>
      ) : null}

      {!insufficientCoin && insufficientPool ? (
        <p className="bdraw-ticket-note error">Pool too low — try fewer picks.</p>
      ) : null}
    </div>
  );
};

export default BondDrawTicket;
